import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SyriaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15943'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15943)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#E32139'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66648 7.7653L5.54689 8.51013L5.92375 7.23647L4.85494 6.42314L6.20745 6.3808L6.66648 5.1333L7.12551 6.3808L8.47802 6.42314L7.40921 7.23647L7.78607 8.51013L6.66648 7.7653Z'
					fill='#128A49'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.3325 7.7653L12.2129 8.51013L12.5898 7.23647L11.521 6.42314L12.8735 6.3808L13.3325 5.1333L13.7915 6.3808L15.144 6.42314L14.0752 7.23647L14.4521 8.51013L13.3325 7.7653Z'
					fill='#128A49'
				/>
			</g>
		</svg>
	);
};

export default SyriaFlagIcon;
